<script>
import { mapGetters, mapState } from 'vuex';
import store from '@/store';
import brfssRouterLink from '@/components/sub/brfssRouterLink';
import Events from '@/bo/Events.js';

/* eslint no-mixed-spaces-and-tabs: 'off', no-tabs: 'off' */
export default {
    props: ['group'],
    //inject: ['emitter'], //Get emitter from the
    // setup: function () {
    //     const emitter = inject('emitter');
    // },
    render(h) {
        const vm = this;
        if (vm.group.menu.length === 0) return '';

        var headerItems = [];
        const g = vm.group;

        if (g)
            headerItems.push(
                h(
                    'a',
                    {
                        attrs: {
                            class: 'group-link',
                            href: '#'
                        },
                        on: {
                            click: (e) => vm.redirectUser(e, g)
                        }
                    },
                    g.title
                )
            );
        else headerItems.push(h('span', {}, g.title));

        var title = h('title', {}, 'expand');

        const svgPath = getSvgPath(vm.isExpanded);

        var path = <path d={svgPath} />;
        var svg = h('svg', { attrs: { viewBox: '0 0 24 24' } }, [title, path]);

        var anchor = h(
            'a',
            {
                ref: 'expandCollapseLink',
                attrs: {
                    href: '#',
                    class: vm.isExpanded ? 'nav-minus' : 'nav-plus',
                    'data-toggle': vm.isExpanded ? 'collapse' : 'expand'
                },
                on: {
                    click: vm.expandCollapse
                }
            },
            [svg]
        );

        headerItems.push(anchor);

        var header = h(
            'div',
            {
                class: 'h4'
            },
            headerItems
        );

        var items = '';
        if (vm.isExpanded) {
            const allItems = vm.group.menu.map((m) =>
                h('brfss-router-link', {
                    props: {
                        isActive: m.url === store.state.display.menuItem,
                        item: m
                    }
                })
            );
            items = <div style="display: block">{allItems}</div>;
        }

        return h(
            'div',
            {
                ref: 'group',
                attrs: {
                    class: vm.isGroupActive ? 'active' : ''
                }
            },
            [header, items]
        );
    },
    computed: {
        ...mapState({
            menuGroup: (state) => state.display.menuGroup,
            menuItem: (state) => state.display.menuItem,
            actions: (state) => state.security.actions,
            isPublic: (state) => state.security.isPublic
        }),
        ...mapGetters({
            menuGroup: 'display/getMenuGroup',
            menuItem: 'display/getMenuItem'
        })
    },
    components: {
        'brfss-router-link': brfssRouterLink
    },
    watch: {
        menuGroup: function (value) {
            let vm = this;
            vm.isGroupActive = vm.menuGroup === vm.group.name;
        }
    },
    mounted() {
        const vm = this;
        this.id = 'navGroup_' + this._uid;
    },
    created: function () {
        let vm = this;
        vm.isExpanded = vm.group.isExpanded;
        vm.myEvents = new Events();
        vm.isGroupActive = vm.menuGroup === vm.group.name;
        vm.myEvents.on('menuGroupSelected', function ({ menuGroup, menuItem }) {
            if (menuGroup.toLowerCase() === vm.group.name.toLowerCase()) {
                vm.isGroupActive = true;
                if (
                    vm.$refs.group &&
                    !vm.$refs.group.classList.contains('active')
                )
                    vm.$refs.group.classList.add('active');
                vm.isExpanded = true;
            } else {
                vm.isGroupActive = false;
            }
        });
    },
    setImage: function (vm) {},
    beforeUnmount() {
        this.myEvents = Events.kill(this.myEvents);
    },
    data: () => {
        let vm = this;
        return {
            id: null,
            isGroupActive: false,
            isExpanded: false,
            myEvents: null
        };
    },
    methods: {
        redirectUser,
        expandCollapse
    }
};

function redirectUser(e, item) {
    let vm = this;
    if (e) e.preventDefault();
    store.dispatch('display/clearMessages');
    if (item.isExternal) window.open(item.url);
    else this.$router.push(item.url);
    return false;
}

//Button clicked
function expandCollapse(e) {
    let vm = this;
    if (e) e.preventDefault();
    vm.isExpanded = !vm.isExpanded;
    return false;
}

function getSvgPath(isExpanded) {
    return isExpanded
        ? 'M19,13H5V11H19V13Z' //minus
        : 'M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z'; //plus
}
</script>

<style scoped>
h4 {
    display: flex;
    flex-direction: column;
}
h4 a:first-child {
    flex-grow: 4;
}

h4 span:hover {
    cursor: default;
    flex-grow: 4;
}

.h4 {
    display: flex;
    flex-direction: column;
}
.h4 a:first-child {
    flex-grow: 4;
}

.h4 span:hover {
    cursor: default;
    flex-grow: 4;
}

.mobile-section-nav nav .dropdown-toggle #svg-down {
    width: 40px;
    height: 40px;
    position: absolute;
    border-radius: 20px;
    right: 30px;
    bottom: -12px;
    z-index: 1002;
    transition: transform 0.4s ease;
    margin-bottom: -8px;
    border: 2px solid #fff;
    fill: #fff;
}
</style>
